import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

export const styles = StyleSheet.create({
  table: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: 20,
    fontFamily: "CustomFontFamily",
    fontSize: 10,
  },
  tableRow: {
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-start",
    minHeight: 20,
    padding: 5,
  },
  tableCell: {
    flex: 1,
    padding: 5,
  },
  textWithImage: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  signatureImage: {
    maxWidth: 120,
    height: 20,
    objectFit: "contain",
    marginLeft: 5,
    alignSelf: "center",
  },
  htmlContent: {
    fontFamily: "CustomFontFamily",
    fontSize: 10,
    flex: 1,
  },
  descHeading: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 4,
    marginTop: 8,
  },
  descText: {
    fontSize: 9,
    lineHeight: 1.5,
    marginBottom: 3,
  },
});

export const TableFooterPdf: React.FC<{
  resKontrolisao: string;
  resPotpis: string;
  kontrolisao?: string | null;
  potpis?: string | null;
}> = ({ resPotpis, resKontrolisao, kontrolisao, potpis }) => (
  <View style={styles.table}>
    <View style={styles.tableRow}>
      <Text>
        {resKontrolisao} : {kontrolisao}
      </Text>
    </View>
    <View style={styles.tableRow}>
      <View style={styles.textWithImage}>
        <Text>{resPotpis} :</Text>
        {potpis && <Image style={styles.signatureImage} src={potpis} />}
      </View>
    </View>
  </View>
);

interface TableRichDescriptionPdfProps {
  richDescription: string;
}

export const TableRichDescriptionPdf: React.FC<
  TableRichDescriptionPdfProps
> = ({ richDescription }) => {
  if (!richDescription || !richDescription.trim()) return null;

  // Split into lines and render each one — no HTML parser needed
  const lines = richDescription.split("\n");

  return (
    <View style={styles.table}>
      <View style={[styles.tableRow, { flexDirection: "column", padding: 8 }]}>
        {lines.map((line, idx) => {
          const trimmed = line.trim();
          if (!trimmed) return null;
          // Treat lines starting with # as headings
          const isHeading = /^#+\s/.test(trimmed);
          const text = trimmed.replace(/^#+\s*/, "").replace(/\*\*/g, "");
          return (
            <Text
              key={idx}
              style={isHeading ? styles.descHeading : styles.descText}
            >
              {text}
            </Text>
          );
        })}
      </View>
    </View>
  );
};
